import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormGroupDirective, UntypedFormControl } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { required } from '../../decorators/required.decorator';
import { getServerErrorForControl } from '../../helpers/form-helper';
import { originalOrder } from '../../pipes/keyvalue-pipe-sort';

@Component({
  selector: 'app-form-field-base',
  template: ``,
  styles: [],
})
export abstract class FormFieldBaseComponent<T> implements OnChanges {
  @Input() @required title!: string;
  @Input() @required formFieldName!: string;
  @Input() isDisabled: boolean = false;
  @Input() disabledTooltipText: string = '';

  @Output() valueChange = new EventEmitter<T>();

  control!: UntypedFormControl;

  constructor(
    readonly rootFormGroup: FormGroupDirective,
    readonly translate: TranslateService
  ) {}

  originalOrder = originalOrder;

  ngOnChanges(): void {
    this.control = this.rootFormGroup.control.get(
      this.formFieldName
    ) as UntypedFormControl;
  }

  onValueChange(value: T): void {
    this.valueChange.emit(value);
  }

  getServerError(): any {
    return getServerErrorForControl(this.control);
  }

  setValue(value: T) {
    this.control.setValue(value);
  }
}
